import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core'
import { FormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms'
import { Property } from '@app/shared/models/common-models'
import { PropertyChangeArgs } from '@app/shared/models/entity-update.model'
import { EntityService } from '@app/shared/services/entity.service'

@Component({
  selector: 'app-entity-text-property',
  templateUrl: './text-property.component.html',
  styleUrls: ['./text-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextPropertyComponent implements OnChanges {
  @Input() property: Property

  @Input() formGroup: UntypedFormGroup

  @Output() propertyChange = new EventEmitter<PropertyChangeArgs>()

  propertyForm: FormControl<string>

  toolTipTextId: string

  private hasFocus: boolean

  constructor(private entityService: EntityService) {
    this.propertyForm = new FormControl<string>(null, { updateOn: 'blur' })
    this.propertyForm.valueChanges.subscribe(value => {
      if (this.propertyForm.invalid) {
        return
      }
      const event: PropertyChangeArgs = {
        Key: this.property.Key,
        Value: value,
        MeasurementUnitKey: this.property.MeasurementUnit,
      }
      this.propertyChange.emit(event)
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.property &&
      changes.formGroup &&
      changes.formGroup.currentValue &&
      changes.formGroup.previousValue !== changes.formGroup.currentValue
    ) {
      changes.formGroup.currentValue.setControl(this.property.Key, this.propertyForm, { emitEvent: false })
    }
    if (changes.property && this.property) {
      this.updatePropertyForm()
    }
  }

  onInput() {
    this.propertyForm.markAsDirty()
  }

  onFocus() {
    this.hasFocus = true
  }

  onBlur() {
    this.hasFocus = false
  }

  updatePropertyForm() {
    /**
     * We don't update dirty fields if it has focus, or invalid value.
     * This is way we give user option to finish the input or fix validation error by not replacing the value which count up towards fluent user experience.
     * */
    if (!(this.propertyForm.dirty && (this.hasFocus || this.propertyForm.invalid))) {
      this.propertyForm.setValue(String(this.property.Value ?? ''), { emitEvent: false })
      this.propertyForm.markAsPristine()
    }
    if (this.property.IsEnabled) {
      this.propertyForm.enable({ emitEvent: false })
    } else {
      this.propertyForm.disable({ emitEvent: false })
    }
    // Update validators
    const validators = new Array<ValidatorFn>()
    if (this.property.IsRequired) {
      validators.push(Validators.required)
    }

    this.propertyForm.setValidators(validators)
    this.propertyForm.updateValueAndValidity({ emitEvent: false })

    this.toolTipTextId = this.entityService.getMetadataValue(this.property, 'TooltipTextId')
  }
}
